import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TextField from '@mui/material/TextField';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { Typography, Checkbox } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import getCookie, { setDistrictCookie, userState } from '../../../Atom'
import { updateLaunchtrekFile } from '../api';
import { useHistory } from "react-router-dom";
let newData = [];
export default function EditFile(props) {
    // const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('md');
    const history = useHistory();
    let search = window.location.search;
    let params = new URLSearchParams(search);
    const inputStyle = {
        width: '100%',
        // marginTop: 2,
        "& label": {
            color: "#00000099",
            fontWeight: 500,
            fontSize: 16,
        },
        "& label.Mui-focused": {
            color: "#00000099",
        },

        "& .MuiInput-underline:after": {
            borderBottomColor: "#00000099",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#00000099",
            },
            // "&:hover fieldset": {
            //     borderColor: "#1A273B",
            // },
            "&.Mui-disabled fieldset": {
                borderColor: "none !important"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#00000099",
            },
        },
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none",
        },
        "& input[type=number]": {
            MozAppearance: "textfield",
        },
    };
    const handleClose = (e) => {
        props?.setOpen(false);
    };

    const logoutHandler = async () => {
        setTimeout(() => {
            // setmyUser({
            //   fName: null,
            //   userId: null,
            //   token: null,
            //   lName: null,
            // })
            setDistrictCookie({
                fName: null,
                lName: null,
                token: null,
                userId: null
            })
            let hostname = window.location.host;
            window.location.assign(`${window.location.protocol}//${hostname}/school-district`)
        })
    }

    const saveMetaData = () => {
        newData[props?.index] = { ...props?.metaArr[props?.index], ...props?.metaData };
        props?.setMetaArr(newData)
        props?.setSnackBarShow(true);
        props?.setSnackBarMessage("Meta Data added successfully");
        props?.setSnackBarSeverity("success");
        props?.setOpen(false);

    }
    const editMetaData = async (e) => {
        e.stopPropagation()
        const _cookie = getCookie('recoil-persist')
        if (!_cookie) {
            logoutHandler()
        } else {
            const user = JSON.parse(_cookie)["district_admin_v1"];
            const res = await updateLaunchtrekFile(props?.fileId, props?.metaData, user?.token);
            if (res?.error) {
                if (res?.data?.statusCode == 401) {
                    logoutHandler();
                }
            } else {
                props?.setSnackBarShow(true);
                props?.setSnackBarMessage("Data Edited successfully");
                props?.setSnackBarSeverity("success");
                let urlSerial = params.get('serial')
                history.push({
                    pathname: '/launchtrakfiles',
                    search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + 'page=' + props?.page + '&limit=' + props?.pageLimit
                })
                props?.getLaunchData(user, props?.page, props?.pageLimit)
            }
        }

        handleClose()
        props?.setMetaData({
            name: "",
            pressure: 0,
            volumeOfWater: 0,
            volumeOfEngine: 0,
            nozzleSize: 0,
            rocketDryMass: 0,
            parachuteSize: 0,
            noParachut: false,
        })
    }
    const onSelectParachut=async (value)=>{
        props?.setMetaData((prevState) => ({
            ...prevState,
            noParachut: !props?.metaData?.noParachut,
        }))
        props?.setMetaData((prevState) => ({
            ...prevState,
            parachuteSize: '',
        }))
    }
    return (
        <React.Fragment>
            {/* <EditOutlinedIcon sx={{ color: props?.color, cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); handleClickOpen() }} /> */}
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={props?.open}
            // onClose={handleClose}
            >
                <DialogTitle>  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton></DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 5,
                            // padding: 3
                        }}
                    >
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'row', gap: 2, marginBottom: 25 }}>
                                {/* <ArrowBackOutlinedIcon /> */}
                                <Typography style={{ fontWeight: 500, fontSize: 22 }}>{props?.edit ? "Update MetaData" : "Add MetaData"}</Typography>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 30 }}>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                                    <div style={{ width: '33%' }}>
                                        <TextField id="outlined-basic" label="Name" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.name}
                                            onChange={(e) =>
                                                props?.setMetaData((prevState) => ({
                                                    ...prevState,
                                                    name: e?.target?.value,
                                                }))} />
                                    </div>
                                    <div style={{ width: '33%' }}>
                                        <TextField id="outlined-basic" type='number' label="Pressure in PSI" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.pressure || ''}
                                            onChange={(e) =>
                                                props?.setMetaData((prevState) => ({
                                                    ...prevState,
                                                    pressure: Number(e?.target?.value),
                                                }))} />

                                    </div>
                                    <div style={{ width: '33%' }}>
                                        <TextField id="outlined-basic" type='number' label="Volume of water in milliliters" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.volumeOfWater || ''}
                                            onChange={(e) =>
                                                props?.setMetaData((prevState) => ({
                                                    ...prevState,
                                                    volumeOfWater: Number(e?.target?.value),
                                                }))} />

                                    </div>
                                </div>
                                {/* //SECOND DIV */}
                                <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                                    <div style={{ width: '33%' }}>
                                        <TextField id="outlined-basic" type='number' label="Volume of engine in milliliters" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.volumeOfEngine || ''}
                                            onChange={(e) =>
                                                props?.setMetaData((prevState) => ({
                                                    ...prevState,
                                                    volumeOfEngine: Number(e?.target?.value),
                                                }))} />

                                    </div>
                                    <div style={{ width: '33%', height: '40px' }}>
                                        <FormControl sx={inputStyle} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}
                                            onChange={(e) =>
                                                props?.setMetaData((prevState) => ({
                                                    ...prevState,
                                                    nozzleSize: Number(e?.target?.value),
                                                }))}>
                                            <FormLabel id="demo-radio-buttons-group-label">Nozzle size</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue={props?.metaData?.nozzleSize}
                                                name="radio-buttons-group"
                                                style={{ display: 'flex', flexDirection: 'row', marginTop: -15 }}>
                                                <FormControlLabel value="8" control={<Radio style={{ color: '#000000' }} />} label="8 mm" />
                                                <FormControlLabel value="10" control={<Radio style={{ color: '#000000' }} />} label="10 mm" />
                                                <FormControlLabel value="12" style={{ marginRight: '0px' }} control={<Radio style={{ color: '#000000' }} />} label="12mm" />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                    <div style={{ width: '33%' }}>
                                        <TextField id="outlined-basic" type='number' label="Rocket dry mass in grams" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.rocketDryMass || ''}
                                            onChange={(e) =>
                                                props?.setMetaData((prevState) => ({
                                                    ...prevState,
                                                    rocketDryMass: Number(e?.target?.value),
                                                }))}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: '33%' }}>
                                    <TextField id="outlined-basic"  disabled={props?.metaData?.noParachut} type='number' label="Parachute size in sq meters" variant="outlined" sx={inputStyle} size='small' value={props?.metaData?.parachuteSize || ''}
                                        onChange={(e) =>
                                            props?.setMetaData((prevState) => ({
                                                ...prevState,
                                                parachuteSize: Number(e?.target?.value),
                                            }))}

                                    />

                                </div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={props?.metaData?.noParachut ? true : false}
                                            // onClick={editFeatured}
                                            onChange={(e) =>  onSelectParachut()}
                                            style={{
                                                color: "#0000004D",
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography
                                            variant="subtitle1"
                                            className="text-[#00000033]"
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: 14,
                                                fontFamily: "Inter",
                                            }}
                                        >
                                            No parachute
                                        </Typography>
                                    }
                                />
                            </div>
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => props?.edit ? editMetaData(e) : saveMetaData(e)}
                        disabled={props?.metaData?.noParachut || props?.metaData?.parachuteSize || props?.metaData?.rocketDryMass || props?.metaData?.nozzleSize || props?.metaData?.volumeOfWater || props?.metaData?.pressure || props?.metaData?.name ? false : true}
                        sx={{
                            width: '129px',
                            height: '55px',
                            borderRadius: '4.62px',
                            backgroundColor: '#348BE3',
                            color: '#FFFFFF',
                            textTransform: 'none',
                            alignItems: 'center !important',
                            ":hover": { backgroundColor: '#348BE3' },
                            ":disabled": { opacity: '50%' }
                        }}
                    >Done</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
